import React from "react";
import PageTitle from "../assets/images/city-image-navigation.jpeg";
export default function Sss() {
  return (
    <div className="container-fluid animate pageWrapper">
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>SIK&#199;A SORULAN SORULAR</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"}{" "}
                  <a href="#">SIK&#199;A SORULAN SORULAR</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}

        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--sikca-sorulan-sorular--> */}
            <div className="row">
              <div className="col-lg-12">
                <div className="accardion">
                  <ul>
                    <li>
                      <span className="Button">Shell TTS nedir?</span>
                      <span className="Capsule">
                        <p>
                          Akaryakıt harcamalarının tek merkezden kontrol altına
                          alınmasını sağlayan bilgisayar destekli bir
                          ara&ccedil; y&ouml;netim sistemidir.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        T&#252;m Shell istasyonlarında Taşıt Tanıma Sistemi var
                        mıdır?
                      </span>
                      <span className="Capsule">
                        <p>
                          T&uuml;rkiye&rsquo;deki 1000
                          &uuml;zeri&nbsp;&nbsp;Shell istasyonunda&nbsp; TTS
                          hizmeti verilmektedir.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell TTS sahibi olabilmek i&#231;in bir ara&#231; adedi
                        limiti var mıdır?
                      </span>
                      <span className="Capsule">
                        <p>
                          Bir ara&ccedil; limiti bulunmamaktadır. Sadece bir
                          ara&ccedil; kullanımında da Shell TTS
                          kullanabilirsiniz.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Araca takılan Shell TTS Ekipmanı, s&#246;k&#252;l&#252;p
                        başka bir araca takılarak kullanılabilir mi?
                      </span>
                      <span className="Capsule">
                        <p>
                          Shell TTS &uuml;nitelerinin mevcut şirket aracından
                          s&ouml;k&uuml;l&uuml;p başka bir araca takılması
                          m&uuml;mk&uuml;n değildir. Yeni ara&ccedil;
                          i&ccedil;in yeni cihaz talebinde bulunulması
                          gerekmektedir.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell TTS’nin araca takılma işlemi, aracın garantisini
                        bozar mı?
                      </span>
                      <span className="Capsule">
                        <p>
                          Shell TTS &uuml;niteleri araca herhangi bir zarar
                          vermez, garantisini de bozmaz.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell TTS kullanabilmek i&#231;in işlemler ne kadar
                        zamanda tamamlanır?
                      </span>
                      <span className="Capsule">
                        <p>
                          &quot;Sistemi kullanmaya başlayabilmek i&ccedil;in
                          gerekli S&ouml;zleşme ve Evraklar tamamlanmalıdır.
                          Taşıt Tanıma &Uuml;nitelerinin G&ouml;nderimi,
                          S&ouml;zleşme ve ekli evraklar tarafımıza ulaştıktan
                          sonra, Akıllı anahtarlık MNG Kargo aracılığıyla 7 iş
                          g&uuml;n&uuml; i&ccedil;erisinde m&uuml;şteriye kargo
                          ile ulaştırılır. Akıllı halka ise sistem tarafından
                          alınan ID numaralara istinaden en yakın turpak
                          servisinde aynı g&uuml;n montajı yapılabilir.&quot;
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell TTS kullanımı i&#231;in gerekli S&#246;zleşme ve
                        Evraklar nelerdir?
                      </span>
                      <span className="Capsule">
                        <p>
                          <b>Kurumsal Firmalarda;</b>
                          <br />
                          Vergi levhası
                          <br />
                          Ticaret sicil gazetesi
                          <br />
                          İmza sirk&uuml;leri
                          <br />
                          Ruhsat Fotokopileri
                          <br />
                          <br />
                          <b>Şahıs Firmalarında;</b>
                          <br />
                          Kimlik fotokopisi
                          <br />
                          İmza beyannamesi
                          <br />
                          Vergi Levhası
                        </p>

                        <p>
                          Sisteme dahil olmak i&ccedil;in 4 teminat şeklinden
                          birini se&ccedil;ebilirsiniz.
                        </p>

                        <p>
                          Shell TTS kullanımı i&ccedil;in şirketimiz adına
                          tanımlanacak hesap tutarı, aylık yakıt
                          t&uuml;ketiminizi karşılayacak tutarda olmalıdır.
                        </p>

                        <p>
                          1)&nbsp;
                          <b>DBS Doğrudan Bor&ccedil;landırma Sistemi:</b>
                          &nbsp;Buradaki bankalardan DBS i&ccedil;in kredili
                          hesap a&ccedil;tırabilirsiniz. Tanımlanan limitinizden
                          harcanan tutar her fatura d&ouml;neminde otomatik
                          olarak bu hesabınızdan &ccedil;ekilir.
                          <br />
                          2)&nbsp;<b>Kredi Kartı:</b>&nbsp;DBS ya da Teminat
                          mektubu gerektirmeden kredi kartı ile &ouml;n
                          &ouml;demesiz ve blokesiz hizmet!&nbsp; &nbsp;Hemen
                          satın al ile bu işlemi hızlı bir şekilde
                          başlatabilirsiniz.
                          <br />
                          3)&nbsp;<b>Teminat Mektubu:</b>&nbsp;Aylık
                          t&uuml;ketiminiz tutarı kadar &ccedil;alışmakta
                          olduğunuz banka tarafından kesin ve s&uuml;resiz
                          olarak hazırlanmalıdır.
                          <br />
                          4)&nbsp;<b>Nakit Blokaj:</b>&nbsp;Anlaşma boyunca bir
                          defaya mahsus olmak &uuml;zere aylık t&uuml;ketim
                          tutarı şirket hesabına EFT ve ya havale yoluyla
                          yatırılır.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Yakıt alımından sonra istasyondan fatura veya fiş alacak
                        mıyım?
                      </span>
                      <span className="Capsule">
                        <p>
                          Herhangi bir fiş veya fatura almadan ara&ccedil;tan
                          inmeden akaryakıt alım işlemini
                          tamamlayabilirsiniz.Alınan yakıtların faturaları ayda
                          iki kez kesilir ve e-fatura veya e-arşiv fatura olarak
                          tanımlı mail adresinize g&ouml;nderilir
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Sistemi kullanarak otogaz alabilir miyim?
                      </span>
                      <span className="Capsule">
                        <p>Oto gaz alımlarında kullanılmamaktadır.</p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Aracıma hatalı dolum yapılma ihtimali var mı?
                      </span>
                      <span className="Capsule">
                        <p>
                          Aracınız i&ccedil;in programlanmış cihaz sayesinde her
                          zaman doğru akaryakıt aldığınızdan emin olursunuz.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        TTS ile farklı marka akaryakıt istasyonlarından
                        faydalanabilir miyim?
                      </span>
                      <span className="Capsule">
                        <p>
                          Sistem yanlızca Shell akaryakıt istasyonlarında
                          &ccedil;alışmaktadır
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell TTS ile hangi bilgiler alınabilir?
                      </span>
                      <span className="Capsule">
                        <p>
                          Shell TTS ile firma adı, tarih, saat, alınan yakıt
                          cinsi, alınan yakıt miktarı (LT), alınan yakıt tutarı
                          (TL), yakıt alınan istasyon bilgileri gibi
                          &ldquo;yakıt alımına ait bilgilere&rdquo; online
                          ulaşabilirsiniz.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell TTS &#252;niteleri monte edilirken bir &#252;cret
                        &#246;denir mi?
                      </span>
                      <span className="Capsule">
                        <p>
                          &quot;&Uuml;cretsiz montaj yapılmaktadır ve
                          b&uuml;t&uuml;n cihazlar anlaşma s&uuml;resince
                          &uuml;cretsiz teslim edilmektedir.
                        </p>

                        <p>
                          5 ara&ccedil; &uuml;zeri i&ccedil;in montaj servisi
                          firma adresinize gelip, Shell TTS &uuml;nitelerinin
                          montajlarını tamamlar. Diğer talepler montaj
                          servisinde ger&ccedil;ekleşir.&quot;
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        İş makinaları ve jenerat&#246;r i&#231;in cihaz
                        &#252;retimi yapılabilir mi?
                      </span>
                      <span className="Capsule">
                        <p>
                          İş makineleri ve jernerat&ouml;rlere cihaz
                          programlaması yapılabilir. Bunun i&ccedil;in her bir
                          iş makinesine ait şirket adına d&uuml;zenlenmiş
                          ara&ccedil; sicil ve seri numaralarının bulunduğu
                          fatura yada ruhsatı g&ouml;nderilmelidir.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Aracın &#231;alınması, kazası yada cihazın arızalanması
                        durumunda ne yapmalıyım?
                      </span>
                      <span className="Capsule">
                        <p>
                          &quot;En kısa s&uuml;rede https://tts.turkiyeshell.com
                          adresinden kullanıcı adı ve şifresi ile giriş yaparak
                          ilgili filo y&ouml;netimi sekmesinden ilgili plakayı
                          yakıt alımına kapatmalı ya da akıllı halka cihaz
                          iptali sekmesinden cihazı iptal etmelisiniz.
                        </p>

                        <p>
                          Hafta i&ccedil;i her g&uuml;n 08:30-17:30 saatleri
                          i&ccedil;erisinde info@kit-tak.com adresine mail
                          atarak işleminizi ger&ccedil;ekleştirebilirsiniz&quot;
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Kayıp &#199;alıntı cihazlarda bedel &#246;denir mi?
                      </span>
                      <span className="Capsule">
                        <p>
                          Cihazlar 2.kez programlanabilir.Kayıp &ccedil;alıntı
                          durumlarında Akıllı anahtar ise cihazın 2.sefer
                          tanımlanması i&ccedil;in cihaz bedeli tahsil edilir.
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <!--/sikca-sorulan-sorular--> */}
          </div>
        </div>
        {/* <!--/page--> */}
      </div>
    </div>
  );
}
